"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { ChevronDown, Plus } from "lucide-react";
import * as React from "react";
import { controlNewWorkspaceModal, NewWorkspaceModal } from "@/components/dashboards/NewWorkspaceModal";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { useUserData } from "@/hooks/useUserData";
import { cn, getInitials } from "@/lib/utils";
import { hasWorkspacePermission } from "@/lib/utils/workspace-permissions";
interface WorkspaceSwitcherProps {
  selectorMode?: boolean;
  className?: string;
}
export function WorkspaceSwitcher(t0) {
  const $ = _c(65);
  const {
    selectorMode: t1,
    className
  } = t0;
  const selectorMode = t1 === undefined ? false : t1;
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    workspace,
    updateCurrentWorkspace
  } = useCurrentWorkspace();
  const {
    userData,
    workspaces,
    organization
  } = useUserData();
  let workspaceName = workspace?.name;
  const hasUserRole = !!userData?.role;
  const t2 = workspace?.permissions;
  let t3;
  if ($[0] !== t2) {
    t3 = hasWorkspacePermission(t2, "workspace", "canCreate");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const canCreateWorkspace = t3;
  if (selectorMode) {
    workspaceName = "Select a workspace";
  }
  const t4 = workspaceName ?? "";
  let t5;
  if ($[2] !== t4) {
    t5 = getInitials(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const workspaceNameInitial = t5;
  let t6;
  if ($[4] !== className) {
    t6 = cn(className);
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = !selectorMode && "data-[state=open]:bg-sidebar-accent/20 border-sidebar-accent/10 hover:border-sidebar-accent/30 data-[state=open]:border-sidebar-accent/30 text-sidebar-foreground hover:text-sidebar-foreground";
  let t8;
  if ($[6] !== t7) {
    t8 = cn(t7, "border bg-sidebar-accent/10 hover:bg-sidebar-accent/10");
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = !hasUserRole;
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(true);
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== organization || $[10] !== workspaceName) {
    t11 = organization?.logo ? <AspectRatio ratio={1}><AvatarImage alt={organization.name || workspaceName} className="h-full w-full object-cover" src={organization.logo} /></AspectRatio> : null;
    $[9] = organization;
    $[10] = workspaceName;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== workspaceNameInitial) {
    t12 = <AvatarFallback className="rounded-none bg-accent/60 text-accent-foreground">{workspaceNameInitial}</AvatarFallback>;
    $[12] = workspaceNameInitial;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t11 || $[15] !== t12) {
    t13 = <Avatar className="size-8 rounded-md border border-sidebar-accent">{t11}{t12}</Avatar>;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== workspaceName) {
    t14 = <div className="grid flex-1 text-left text-sm leading-tight"><span className="truncate font-medium">{workspaceName}</span></div>;
    $[17] = workspaceName;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ChevronDown className="ml-auto" />;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t13 || $[21] !== t14 || $[22] !== t8 || $[23] !== t9) {
    t16 = <DropdownMenuTrigger asChild={true}><SidebarMenuButton className={t8} disabled={t9} onClick={t10} size="lg">{t13}{t14}{t15}</SidebarMenuButton></DropdownMenuTrigger>;
    $[20] = t13;
    $[21] = t14;
    $[22] = t8;
    $[23] = t9;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  const t17 = !selectorMode && "bg-[color-mix(in_oklch,var(--color-sidebar),white_5%)] border-sidebar-accent/40";
  let t18;
  if ($[25] !== t17) {
    t18 = cn("w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg", t17);
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  const t19 = !selectorMode && "text-sidebar-foreground";
  let t20;
  if ($[27] !== t19) {
    t20 = cn(" text-xs flex items-center justify-between", t19);
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span>Workspaces</span>;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== workspaces.length) {
    t22 = <span>{workspaces.length}</span>;
    $[30] = workspaces.length;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== t20 || $[33] !== t22) {
    t23 = <DropdownMenuLabel className={t20}>{t21}{t22}</DropdownMenuLabel>;
    $[32] = t20;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <DropdownMenuSeparator className="bg-sidebar-accent/40" />;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      maxHeight: "200px"
    };
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] !== organization || $[38] !== selectorMode || $[39] !== updateCurrentWorkspace || $[40] !== workspace?.id || $[41] !== workspaces) {
    let t27;
    if ($[43] !== organization || $[44] !== selectorMode || $[45] !== updateCurrentWorkspace || $[46] !== workspace?.id) {
      t27 = t28 => {
        const {
          id,
          name
        } = t28;
        const isCurrentWorkspace = id === workspace?.id;
        return <DropdownMenuItem className={cn("gap-2 p-2 data-disabled:opacity-70", !selectorMode && "text-sidebar-foreground")} key={id} onClick={() => {
          updateCurrentWorkspace(id);
          setIsOpen(false);
        }}><Avatar className="size-10 rounded-md border border-sidebar-accent">{organization?.logo ? <AspectRatio ratio={1}><AvatarImage alt={organization.name || name} className="h-full w-full object-cover" src={organization.logo} /></AspectRatio> : null}<AvatarFallback className={cn("rounded-none", selectorMode ? "border-sidebar-accent bg-accent" : "bg-sidebar-accent text-accent-foreground")}>{getInitials(name)}</AvatarFallback></Avatar><div className="grid flex-1 text-left text-[13px] leading-tight"><span className="truncate font-medium">{name}</span>{isCurrentWorkspace && <span className="text-[10px]">(Current)</span>}</div></DropdownMenuItem>;
      };
      $[43] = organization;
      $[44] = selectorMode;
      $[45] = updateCurrentWorkspace;
      $[46] = workspace?.id;
      $[47] = t27;
    } else {
      t27 = $[47];
    }
    t26 = workspaces.map(t27);
    $[37] = organization;
    $[38] = selectorMode;
    $[39] = updateCurrentWorkspace;
    $[40] = workspace?.id;
    $[41] = workspaces;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[48] !== t26) {
    t27 = <ScrollArea style={t25}>{t26}</ScrollArea>;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== canCreateWorkspace) {
    t28 = canCreateWorkspace && <><DropdownMenuSeparator className="bg-sidebar-accent/40" /><Button className="w-full rounded-t-none rounded-b-sm" onClick={() => {
        controlNewWorkspaceModal({
          state: "on"
        });
        setIsOpen(false);
      }} variant="secondary"><Plus />New Workspace</Button></>;
    $[50] = canCreateWorkspace;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t18 || $[53] !== t23 || $[54] !== t27 || $[55] !== t28) {
    t29 = <DropdownMenuContent align="start" className={t18} side="bottom" sideOffset={4}>{t23}{t24}{t27}{t28}</DropdownMenuContent>;
    $[52] = t18;
    $[53] = t23;
    $[54] = t27;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== isOpen || $[58] !== t16 || $[59] !== t29) {
    t30 = <SidebarMenuItem><DropdownMenu onOpenChange={setIsOpen} open={isOpen}>{t16}{t29}</DropdownMenu></SidebarMenuItem>;
    $[57] = isOpen;
    $[58] = t16;
    $[59] = t29;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <NewWorkspaceModal />;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t30 || $[63] !== t6) {
    t32 = <SidebarMenu className={t6}>{t30}{t31}</SidebarMenu>;
    $[62] = t30;
    $[63] = t6;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  return t32;
}